export default __webpack_public_path__ + "static/media/work_second.a0c844fa.png";